import { useAppDispatch } from '@mediashop/app/store/hooks/hooks';
import { useEffect } from 'react';
import { fallbackProductIdsReceived } from '@mediashop/app/store/reducer/product';
import { ProductsPreCheckoutProps } from '../../../bloomreach/ProductsPreCheckout';

const ProductsPreCheckout = ({ productIDs }: ProductsPreCheckoutProps) => {
    const dispatch = useAppDispatch();

    useEffect(() => {
        const productIds = Object.values(productIDs);
        dispatch(fallbackProductIdsReceived({ productIds }));
    }, []);

    return null;
};

export default ProductsPreCheckout;
